import React, {useEffect, useState} from 'react';
import BackToTop from '../../../assets/backtotop.svg';
import styled from 'styled-components';

const BackToTopButton = styled.div`
    position: fixed;
    bottom: 84px;
    right: 20px;
    width: 46px;
    height: 46px;
    z-index: 99999;

    img {
        width: 46px;
        height: 46px;
        border-radius: 3px;
    }
`;

  
const ScrollToTopButton = () =>{
  
    const [visible, setVisible] = useState(false)
    
    const toggleVisible = () => {
      const scrolled = document.documentElement.scrollTop;
      if (scrolled > 50){
        setVisible(true)
      } 
      else if (scrolled <= 50){
        setVisible(false)
      }
    };
    
    const scrollToTop = () =>{
      window.scrollTo({
        top: 0, 
        behavior: 'smooth'
      });
    };
    
    window.addEventListener('scroll', toggleVisible);
    
    return (
       <BackToTopButton onClick={scrollToTop} 
       style={{display: visible ? 'inline' : 'none'}}>
           <img src={BackToTop} />
       </BackToTopButton>
    );
  }
    
export default ScrollToTopButton;
